import * as React from 'react';
import { type LucideIcon } from 'lucide-react';
import { IFirmwareDistribution, IUpdateStatusData } from '../analytics.types';

interface IVersionDistributionCardProps {
  title: string;
  icon: LucideIcon;
  versions: IFirmwareDistribution[];
  updateStatus: IUpdateStatusData[];
  barVariant: 'firmware' | 'iot';
}

const VersionDistributionCard = ({
  title,
  icon: Icon,
  versions,
  updateStatus,
  barVariant,
}: IVersionDistributionCardProps) => {
  const barClass = barVariant === 'firmware' ? 'firmware-bar' : 'iot-bar';

  const hasVersionData = versions.some(
    (versionItem) => versionItem.deviceCount > 0 || versionItem.percentage > 0
  );

  const hasStatusData = updateStatus.some(
    (statusItem) => statusItem.count > 0 || statusItem.percentage > 0
  );

  const showEmptyState = !hasVersionData && !hasStatusData;

  const emptyMessage =
    barVariant === 'firmware'
      ? 'No firmware version data available.'
      : 'No IoT agent version data available.';

  return (
    <div className="analytics-card">
      <div className="card-title">
        <Icon size={20} strokeWidth={1.5} />
        <h2>{title}</h2>
      </div>

      {showEmptyState ? (
        <div className="analytics-empty-state">{emptyMessage}</div>
      ) : (
        <>
          <div className="version-distribution">
            {versions.map((versionItem) => (
              <div key={versionItem.version} className="version-row">
                <div className="version-info">
                  <span className="version-name">{versionItem.version}</span>
                  <span className="version-count">
                    {versionItem.deviceCount} devices
                  </span>
                </div>
                <div className="version-bar-container">
                  <div
                    className={`version-bar ${barClass}`}
                    style={{ width: `${versionItem.percentage}%` }}
                  />
                </div>
                <span className="version-percentage">
                  {versionItem.percentage}%
                </span>
              </div>
            ))}
          </div>

          <div className="update-status-section">
            <h3>Update Status</h3>
            <div className="status-pills">
              {updateStatus.map((statusItem) => (
                <div key={statusItem.status} className="status-pill">
                  <span
                    className="status-dot"
                    style={{ backgroundColor: statusItem.color }}
                  />
                  <span className="status-label">{statusItem.status}</span>
                  <span className="status-value">{statusItem.count}</span>
                  <span className="status-pct">({statusItem.percentage}%)</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default VersionDistributionCard;